module.exports = "/3068/img/video-member-bg.eaab7e7f.png";